import type { LocaleMessageBundle } from '../../types'

export const transferOrderMessages: LocaleMessageBundle = {
  vi: {
    'inventory.transferOrder.title': 'Chuyển hàng',
    'inventory.transferOrder.actions.create': 'Tạo phiếu',
    'inventory.transferOrder.actions.view': 'Xem chi tiết',
    'inventory.transferOrder.actions.edit': 'Cập nhật',
    'inventory.transferOrder.actions.submit': 'Gửi yêu cầu',
    'inventory.transferOrder.actions.confirm': 'Xác nhận chuyển',
    'inventory.transferOrder.actions.receive': 'Nhận hàng',
    'inventory.transferOrder.actions.cancel': 'Hủy',
    'inventory.transferOrder.actions.delete': 'Xóa phiếu',
    'inventory.transferOrder.actions.deleteTitle': 'Xóa phiếu chuyển nháp',
    'inventory.transferOrder.messages.deleteConfirm': 'Bạn có chắc muốn xóa phiếu chuyển {code}?',
    'inventory.transferOrder.actions.cancelConfirm': 'Hủy',
    'inventory.transferOrder.actions.export': 'Xuất Excel',
    'inventory.transferOrder.actions.import': 'Nhập Excel',
    'inventory.transferOrder.actions.downloadTemplate': 'Tải file mẫu',
    'inventory.transferOrder.actions.addLine': 'Thêm dòng',
    'inventory.transferOrder.actions.addTab': 'Thêm phiếu chuyển',
    'inventory.transferOrder.actions.closeTab': 'Đóng phiếu chuyển',
    'inventory.transferOrder.tabs.draft': 'Chuyển hàng {number}',
    'inventory.transferOrder.actions.saveTemp': 'Lưu tạm',
    'inventory.transferOrder.actions.complete': 'Hoàn thành',
    'inventory.transferOrder.fields.code': 'Mã phiếu',
    'inventory.transferOrder.fields.fromBranch': 'Chi nhánh gửi hàng',
    'inventory.transferOrder.fields.toBranch': 'Chi nhánh nhận/yêu cầu',
    'inventory.transferOrder.fields.transferDate': 'Ngày chuyển',
    'inventory.transferOrder.fields.receiveDate': 'Ngày nhận',
    'inventory.transferOrder.fields.quantityTransfer': 'SL chuyển',
    'inventory.transferOrder.fields.quantityReceived': 'SL nhận',
    'inventory.transferOrder.fields.transferPrice': 'Giá chuyển',
    'inventory.transferOrder.fields.total': 'Thành tiền',
    'inventory.transferOrder.fields.sourceLocation': 'Vị trí xuất',
    'inventory.transferOrder.fields.destinationLocation': 'Vị trí nhận',
    'inventory.transferOrder.fields.receiveNote': 'Ghi chú nhận hàng',
    'inventory.transferOrder.fields.cancelReason': 'Lý do hủy',
    'inventory.transferOrder.fields.historyAction': 'Hành động',
    'inventory.transferOrder.fields.statusChange': 'Thay đổi trạng thái',
    'inventory.transferOrder.fields.historyTime': 'Thời gian',
    'inventory.transferOrder.fields.createdBy': 'Người tạo',
    'inventory.transferOrder.fields.confirmedBy': 'Người duyệt chuyển',
    'inventory.transferOrder.fields.receivedBy': 'Người nhận hàng',
    'inventory.transferOrder.fields.cancelledBy': 'Người hủy phiếu',
    'inventory.transferOrder.fields.itemCount': 'Số mặt hàng',
    'inventory.transferOrder.fields.totalQuantity': 'Tổng SL chuyển',
    'inventory.transferOrder.sections.general': 'Thông tin chung',
    'inventory.transferOrder.sections.products': 'Danh sách hàng hóa',
    'inventory.transferOrder.sections.history': 'Lịch sử thao tác',
    'inventory.transferOrder.statuses.temp': 'Nháp',
    'inventory.transferOrder.statuses.pending': 'Chờ xác nhận',
    'inventory.transferOrder.statuses.transferring': 'Đang chuyển',
    'inventory.transferOrder.statuses.received': 'Đã nhận',
    'inventory.transferOrder.statuses.cancelled': 'Đã hủy',
    'inventory.transferOrder.filters.searchPlaceholder': 'Tìm mã phiếu hoặc chi nhánh',
    'inventory.transferOrder.emptyItems': 'Chưa có hàng hóa trong phiếu chuyển.',
    'inventory.transferOrder.productSearch': 'Tìm sản phẩm theo tên, SKU, barcode...',
    'inventory.transferOrder.selectSourceFirst': 'Chọn chi nhánh gửi hàng trước để tìm sản phẩm',
    'inventory.transferOrder.available': 'Tồn khả dụng: {quantity}',
    'inventory.transferOrder.currentBranch': 'Chi nhánh hiện tại: {branch}',
    'inventory.transferOrder.detailTitle': 'Chi tiết phiếu chuyển',
    'inventory.transferOrder.createTitle': 'Chuyển hàng',
    'inventory.transferOrder.editTitle': 'Cập nhật phiếu chuyển - {code}',
    'inventory.transferOrder.receiveTitle': 'Xác nhận nhận hàng - {code}',
    'inventory.transferOrder.cancelTitle': 'Hủy phiếu chuyển hàng',
    'inventory.transferOrder.cancelConfirm': 'Bạn có chắc muốn hủy phiếu chuyển {code}?',
    'inventory.transferOrder.confirmTitle': 'Xác nhận chuyển hàng',
    'inventory.transferOrder.confirmMessage': 'Xác nhận xuất kho cho phiếu {code}?',
    'inventory.transferOrder.messages.differenceNote':
      'Số lượng nhận khác số lượng chuyển. Vui lòng nhập lý do thiếu, hư hoặc mất.',
    'inventory.transferOrder.messages.imported': 'Đã nhập {added} dòng, bỏ qua {skipped} dòng.',
    'inventory.transferOrder.messages.saved': 'Đã lưu phiếu chuyển hàng.',
    'inventory.transferOrder.messages.submitted': 'Đã gửi yêu cầu chuyển hàng.',
    'inventory.transferOrder.messages.confirmed': 'Đã xác nhận xuất hàng.',
    'inventory.transferOrder.messages.received': 'Đã xác nhận nhận hàng.',
    'inventory.transferOrder.messages.cancelled': 'Đã hủy phiếu chuyển hàng.',
    'inventory.transferOrder.messages.deleted': 'Đã xóa phiếu chuyển nháp.',
    'inventory.transferOrder.messages.exported': 'Đã xuất danh sách chuyển hàng.',
    'inventory.transferOrder.errors.cancelReasonRequired': 'Vui lòng nhập lý do hủy.',
    'inventory.transferOrder.errors.cancelReasonTooLong':
      'Lý do hủy không được vượt quá {max} ký tự.',
    'inventory.transferOrder.errors.branchRequired': 'Vui lòng chọn chi nhánh gửi hàng.',
    'inventory.transferOrder.errors.itemsRequired': 'Vui lòng thêm ít nhất một hàng hóa hợp lệ.',
    'inventory.transferOrder.errors.sameBranch': 'Chi nhánh gửi hàng phải khác chi nhánh hiện tại.',
    'inventory.transferOrder.errors.quantityInvalid': 'Số lượng chuyển phải lớn hơn 0.',
    'inventory.transferOrder.errors.transferDateRequired': 'Vui lòng chọn ngày chuyển.',
    'inventory.transferOrder.errors.quantityExceeded': 'Số lượng chuyển vượt quá tồn khả dụng.',
    'inventory.transferOrder.errors.priceInvalid': 'Giá chuyển phải là số từ 0 đến {max}.',
    'inventory.transferOrder.errors.amountOutOfRange':
      'Thành tiền vượt quá giới hạn cho phép. Tối đa {max}.',
    'inventory.transferOrder.errors.productRequired': 'Vui lòng chọn sản phẩm.',
    'inventory.transferOrder.errors.unitRequired': 'Vui lòng chọn đơn vị.',
    'inventory.transferOrder.errors.duplicateProduct': 'Sản phẩm đã có trong phiếu chuyển.',
    'inventory.transferOrder.errors.integerQuantity': 'Đơn vị này chỉ cho phép số lượng nguyên.',
    'inventory.transferOrder.errors.receiveExceeded':
      'Số lượng nhận không được lớn hơn số lượng chuyển.',
    'inventory.transferOrder.errors.noteRequired': 'Vui lòng nhập ghi chú cho phần chênh lệch.',
    'inventory.transferOrder.errors.importFailed': 'Không thể đọc file Excel chuyển hàng.',
    'inventory.transferOrder.errors.invalidFile':
      'Vui lòng chọn file .xlsx hoặc .xls không quá 5 MB.',
    'inventory.transferOrder.errors.exportFailed': 'Không thể xuất danh sách chuyển hàng.',
    'inventory.transferOrder.history.CREATE': 'Tạo phiếu',
    'inventory.transferOrder.history.UPDATE': 'Cập nhật phiếu',
    'inventory.transferOrder.history.SUBMIT': 'Gửi yêu cầu',
    'inventory.transferOrder.history.CONFIRM': 'Xác nhận chuyển',
    'inventory.transferOrder.history.RECEIVE': 'Nhận hàng',
    'inventory.transferOrder.history.CANCEL': 'Hủy phiếu',
  },
  en: {
    'inventory.transferOrder.title': 'Stock transfers',
    'inventory.transferOrder.actions.create': 'Create',
    'inventory.transferOrder.actions.view': 'View detail',
    'inventory.transferOrder.actions.edit': 'Update',
    'inventory.transferOrder.actions.submit': 'Submit request',
    'inventory.transferOrder.actions.confirm': 'Confirm transfer',
    'inventory.transferOrder.actions.receive': 'Receive stock',
    'inventory.transferOrder.actions.cancel': 'Cancel transfer',
    'inventory.transferOrder.actions.delete': 'Delete transfer',
    'inventory.transferOrder.actions.deleteTitle': 'Delete draft transfer',
    'inventory.transferOrder.messages.deleteConfirm': 'Delete transfer {code}?',
    'inventory.transferOrder.actions.cancelConfirm': 'Cancel',
    'inventory.transferOrder.actions.export': 'Export Excel',
    'inventory.transferOrder.actions.import': 'Import Excel',
    'inventory.transferOrder.actions.downloadTemplate': 'Download template',
    'inventory.transferOrder.actions.addLine': 'Add line',
    'inventory.transferOrder.actions.addTab': 'Add transfer order',
    'inventory.transferOrder.actions.closeTab': 'Close transfer order',
    'inventory.transferOrder.tabs.draft': 'Transfer order {number}',
    'inventory.transferOrder.actions.saveTemp': 'Save draft',
    'inventory.transferOrder.actions.complete': 'Complete',
    'inventory.transferOrder.fields.code': 'Transfer code',
    'inventory.transferOrder.fields.fromBranch': 'Sending branch',
    'inventory.transferOrder.fields.toBranch': 'Receiving/requesting branch',
    'inventory.transferOrder.fields.transferDate': 'Transfer date',
    'inventory.transferOrder.fields.receiveDate': 'Receive date',
    'inventory.transferOrder.fields.quantityTransfer': 'Transfer qty.',
    'inventory.transferOrder.fields.quantityReceived': 'Received qty.',
    'inventory.transferOrder.fields.transferPrice': 'Transfer price',
    'inventory.transferOrder.fields.total': 'Line total',
    'inventory.transferOrder.fields.sourceLocation': 'Source location',
    'inventory.transferOrder.fields.destinationLocation': 'Destination location',
    'inventory.transferOrder.fields.receiveNote': 'Receiving note',
    'inventory.transferOrder.fields.cancelReason': 'Cancellation reason',
    'inventory.transferOrder.fields.historyAction': 'Action',
    'inventory.transferOrder.fields.statusChange': 'Status change',
    'inventory.transferOrder.fields.historyTime': 'Time',
    'inventory.transferOrder.fields.createdBy': 'Created by',
    'inventory.transferOrder.fields.confirmedBy': 'Confirmed by',
    'inventory.transferOrder.fields.receivedBy': 'Received by',
    'inventory.transferOrder.fields.cancelledBy': 'Cancelled by',
    'inventory.transferOrder.fields.itemCount': 'Items',
    'inventory.transferOrder.fields.totalQuantity': 'Total transfer qty.',
    'inventory.transferOrder.sections.general': 'General information',
    'inventory.transferOrder.sections.products': 'Products',
    'inventory.transferOrder.sections.history': 'Activity history',
    'inventory.transferOrder.statuses.temp': 'Draft',
    'inventory.transferOrder.statuses.pending': 'Pending',
    'inventory.transferOrder.statuses.transferring': 'Transferring',
    'inventory.transferOrder.statuses.received': 'Received',
    'inventory.transferOrder.statuses.cancelled': 'Cancelled',
    'inventory.transferOrder.filters.searchPlaceholder': 'Search code or branch',
    'inventory.transferOrder.emptyItems': 'No products have been added.',
    'inventory.transferOrder.productSearch': 'Search product by name, SKU, barcode...',
    'inventory.transferOrder.selectSourceFirst':
      'Select a sending branch before searching products',
    'inventory.transferOrder.available': 'Available: {quantity}',
    'inventory.transferOrder.currentBranch': 'Current branch: {branch}',
    'inventory.transferOrder.detailTitle': 'Transfer detail',
    'inventory.transferOrder.createTitle': 'Stock transfers',
    'inventory.transferOrder.editTitle': 'Update transfer - {code}',
    'inventory.transferOrder.receiveTitle': 'Receive stock - {code}',
    'inventory.transferOrder.cancelTitle': 'Cancel stock transfer',
    'inventory.transferOrder.cancelConfirm':
      'Are you sure you want to cancel transfer order {code}?',
    'inventory.transferOrder.confirmTitle': 'Confirm stock transfer',
    'inventory.transferOrder.confirmMessage': 'Issue stock for transfer {code}?',
    'inventory.transferOrder.messages.differenceNote':
      'Received quantity differs from transferred quantity. Enter a shortage or damage reason.',
    'inventory.transferOrder.messages.imported':
      'Imported {added} rows and skipped {skipped} rows.',
    'inventory.transferOrder.messages.saved': 'Stock transfer saved.',
    'inventory.transferOrder.messages.submitted': 'Stock transfer request submitted.',
    'inventory.transferOrder.messages.confirmed': 'Stock issue confirmed.',
    'inventory.transferOrder.messages.received': 'Stock receipt confirmed.',
    'inventory.transferOrder.messages.cancelled': 'Stock transfer cancelled.',
    'inventory.transferOrder.messages.deleted': 'Draft stock transfer deleted.',
    'inventory.transferOrder.messages.exported': 'Stock transfer list exported.',
    'inventory.transferOrder.errors.cancelReasonRequired': 'Cancellation reason is required.',
    'inventory.transferOrder.errors.cancelReasonTooLong':
      'Cancellation reason cannot exceed {max} characters.',
    'inventory.transferOrder.errors.branchRequired': 'Select a sending branch.',
    'inventory.transferOrder.errors.itemsRequired': 'Add at least one valid product.',
    'inventory.transferOrder.errors.sameBranch':
      'Sending branch must differ from the current branch.',
    'inventory.transferOrder.errors.quantityInvalid':
      'Transfer quantity must be greater than zero.',
    'inventory.transferOrder.errors.transferDateRequired': 'Please select the transfer date.',
    'inventory.transferOrder.errors.quantityExceeded': 'Transfer quantity exceeds available stock.',
    'inventory.transferOrder.errors.priceInvalid':
      'Transfer price must be a number between 0 and {max}.',
    'inventory.transferOrder.errors.amountOutOfRange':
      'Line or transfer total exceeds the allowed limit. Maximum {max}.',
    'inventory.transferOrder.errors.productRequired': 'Select a product.',
    'inventory.transferOrder.errors.unitRequired': 'Select a unit.',
    'inventory.transferOrder.errors.duplicateProduct': 'This product is already in the transfer.',
    'inventory.transferOrder.errors.integerQuantity': 'This unit only allows whole quantities.',
    'inventory.transferOrder.errors.receiveExceeded':
      'Received quantity cannot exceed transferred quantity.',
    'inventory.transferOrder.errors.noteRequired': 'Enter a note explaining the difference.',
    'inventory.transferOrder.errors.importFailed': 'Unable to read the transfer Excel file.',
    'inventory.transferOrder.errors.invalidFile':
      'Choose an .xlsx or .xls file no larger than 5 MB.',
    'inventory.transferOrder.errors.exportFailed': 'Unable to export the stock transfer list.',
    'inventory.transferOrder.history.CREATE': 'Created transfer',
    'inventory.transferOrder.history.UPDATE': 'Updated transfer',
    'inventory.transferOrder.history.SUBMIT': 'Submitted request',
    'inventory.transferOrder.history.CONFIRM': 'Confirmed transfer',
    'inventory.transferOrder.history.RECEIVE': 'Received stock',
    'inventory.transferOrder.history.CANCEL': 'Cancelled transfer',
  },
}
